/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAggregate } from '../../models/profile-aggregate';

export interface GetAggregateForProfileId$Params {
  profileId: string;
  programPeriodId: string;
}

export function getAggregateForProfileId(
  http: HttpClient,
  rootUrl: string,
  params: GetAggregateForProfileId$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProfileAggregate>> {
  const rb = new RequestBuilder(rootUrl, getAggregateForProfileId.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('programPeriodId', params.programPeriodId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAggregate>;
    })
  );
}

getAggregateForProfileId.PATH = '/data-mart/profiles/{profileId}/aggregate/{programPeriodId}';
